import { SiInstagram, SiWhatsapp } from "react-icons/si";
import { Logo, SiteLink } from "@/components/brand";
import { navLinks } from "@/components/sections/Navbar";
import { WHATSAPP_DEFAULT } from "@/lib/offer";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-border">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo />
            <p className="mt-2 max-w-xs text-sm text-muted-foreground">
              Sites e sistemas sob medida para empresas.
            </p>
          </div>

          <nav aria-label="Rodapé" className="flex flex-wrap gap-x-6">
            {navLinks.map((link) => (
              <SiteLink
                key={link.href}
                href={link.href}
                data-testid={`footer-link-${link.href.replace(/^\/#?/, "")}`}
                className="py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
              >
                {link.label}
              </SiteLink>
            ))}
          </nav>

          <div className="flex flex-col">
            <a
              href={WHATSAPP_DEFAULT}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-2.5 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              <SiWhatsapp aria-hidden="true" className="h-4 w-4" />
              (19) 99623-4059
            </a>
            <a
              href="https://instagram.com/ambitie.co"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-2.5 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              <SiInstagram aria-hidden="true" className="h-4 w-4" />
              @ambitie.co
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-border pt-6 text-sm text-muted-foreground sm:flex-row sm:justify-between">
          <p>&copy; 2026 Ambitie</p>
          <p>
            Fundada por{" "}
            <a
              href="https://brunomarcosluz.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-4 hover:text-foreground"
            >
              Bruno Luz
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
